/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import CryptoJS from 'crypto-js';

const scr = '9c79dc70E223X3790926A';

export function encrypt (value) {
    return CryptoJS.AES.encrypt(value, scr);
}

export function decrypt (value) {
    return CryptoJS.AES.decrypt(value, scr).toString(CryptoJS.enc.Utf8);
}


// WEBPACK FOOTER //
// ./src/_helpers/crypto.helper.js